import { Campaign, CampaignReference, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

export const findCampaignReferenceById = createFindById<CampaignReference>('campaignReferences');
export const findCampaignReferenceByIdThrows = createFindByIdThrows<CampaignReference>('campaignReferences');

type GetCampaignTelemetryId = (
  state: YammerState,
  campaignId: Campaign['id']
) => CampaignReference['telemetryId'] | undefined;
export const getCampaignTelemetryId: GetCampaignTelemetryId = (state, campaignId) =>
  findCampaignReferenceById(state, campaignId)?.telemetryId;

type GetFulfilledCampaignReferences = (state: YammerState) => Record<string, CampaignReference>;
export const getFulfilledCampaignReferences: GetFulfilledCampaignReferences = (state) =>
  state.campaignReferences.fulfilled.byId;
